import styled from 'styled-components';

export const MobileGalleryStyles = styled.div`
  display: none;
  align-self: center;
  width: 100%;

  @media (max-width: 512px) {
    display: block;
  }

  .control-dots {
    padding-left: 0;
  }
`;

export const Image = styled.div`
  width: 100%;

  & img {
    width: 100%;
  }
`;
